module.exports = __webpack_public_path__ + "img/logo.d3bc546b.jpg";